// Keeps keyboard focus inside the open overlay and hides the page behind it from screen readers.
(function () {
  var SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  var trapped = null;
  var siblingsHidden = [];

  function focusable(root) {
    return Array.prototype.filter.call(root.querySelectorAll(SELECTOR), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function onKeydown(e) {
    if (!trapped || e.key !== 'Tab') return;
    var items = focusable(trapped);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function hideBackground(panel) {
    siblingsHidden = [];
    var node = panel;
    while (node && node !== document.body) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (child) {
        if (child === node || child.hasAttribute('aria-hidden')) return;
        child.setAttribute('aria-hidden', 'true');
        siblingsHidden.push(child);
      });
      node = parent;
    }
  }

  function showBackground() {
    siblingsHidden.forEach(function (el) { el.removeAttribute('aria-hidden'); });
    siblingsHidden = [];
  }

  window.sannicoTrapFocus = function (panel) {
    if (!panel || trapped === panel) return;
    if (trapped) window.sannicoReleaseFocus(trapped);
    trapped = panel;
    hideBackground(panel);
    document.addEventListener('keydown', onKeydown, true);
  };

  window.sannicoReleaseFocus = function (panel) {
    if (!trapped || (panel && panel !== trapped)) return;
    document.removeEventListener('keydown', onKeydown, true);
    showBackground();
    trapped = null;
  };
})();
